<template>
  <div id="app" class="test" v-if="store.langLoaded">
    <router-view/>
  </div>
</template>

<script>
import store from '@/store'

export default {
  name: 'App',
  data() {
    return {
      store: store
    }
  }
}

</script>
<style>

</style>



// WEBPACK FOOTER //
// src/App.vue